import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import type { UsersHandlers, AccountUserPermissionsHandlers } from '../types';
import AccountUserPermissionsForm from './AccountUserPermissionsForm';

type ChangeAccountUserPermissionProps = {
  accountUserPermissions: vp.AccountUserPermissionsMap;
  handlers: UsersHandlers;
  accountUserEmailAddress: string;
};

type FC = FunctionComponent<ChangeAccountUserPermissionProps>;

const AccountUserPermissions: FC = ({
  accountUserEmailAddress,
  accountUserPermissions,
  handlers: _handlers,
}: ChangeAccountUserPermissionProps) => {
  const handlers: AccountUserPermissionsHandlers = {
    initializeAccountUserPermissions: (value: vp.AccountUserPermissions) => {
      _handlers.initializeAccountUserPermissions(value);
    },

    onAccountUserPermissionChange: (permissionId: vp.AccountUserPermissionsId, updatedValue: string | boolean) => {
      _handlers.onAccountUserPermissionChange(permissionId, updatedValue);
    },

    onAccountUserPermissionSave: () => {
      _handlers.onAccountUserPermissionSave(accountUserEmailAddress);
    },
    onBack: () => {
      _handlers.onBack();
    },
  };

  return (
    <AccountUserPermissionsForm
      accountUserEmailAddress={accountUserEmailAddress}
      accountUserPermissions={{ ...accountUserPermissions }}
      handlers={handlers}
    />
  );
};

export default AccountUserPermissions;
